import ResponsiveModal from './ResponsiveModal';

export default ResponsiveModal;
